__webpack_require__.p = "/gulfnews/assets/";